import { render } from "./sandbox.vue?vue&type=template&id=4fe0c712&ts=true"
import script from "./sandbox.vue?vue&type=script&lang=ts"
export * from "./sandbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__